//路由配置
import Layout from '@/components/Layout';
// import layoutMain from '@/components/Layout';

const list =
    [
        //登录模块
        {
            path: '/login',
            name: 'login',
            component: resolve => { require(['@/views/login/login'], resolve); },
            meta: {
                title: "用户登录"
            }
        },
        //忘记密码
        {
            path: '/forget-password',
            name: 'forget-password',
            component: resolve => { require(['@/views/login/forget-password'], resolve); },
            meta: {
                title: "忘记密码"
            }
        },
        //主页
        {
            path: '/',
            component: Layout,
            meta: {
                title: "首页"
            },
            children: [
                {
                    path: '/',
                    name: 'index',
                    component: resolve => { require(['@/views/index'], resolve); },
                    meta: {
                        title: "首页"
                    }
                },
                {
                    path: '/userinfo',
                    name: 'userinfo',
                    component: resolve => { require(['@/views/account/userinfo'], resolve); },
                    meta: {
                        title: "我的资料"
                    }
                },
            ]
        },
        {
            path: '/account',
            name: 'account',
            component: Layout,
            redirect: "/account/list",
            meta: {
                title: "系统管理",
                navPath: "",
            },
            children: [
                {
                    path: 'list',
                    name: 'account-list',
                    component: resolve => { require(['@/views/account/list'], resolve); },
                    meta: {
                        title: "账号列表",
                    }
                },
                {
                    path: 'edit/:uid',
                    name: 'account-edit',
                    props: true,
                    component: resolve => { require(['@/views/account/create'], resolve); },
                    meta: {
                        title: "编辑用户"
                    }
                },
                {
                    path: 'create',
                    name: 'account-create',
                    component: resolve => { require(['@/views/account/create'], resolve); },
                    meta: {
                        title: "新增用户"
                    }
                },
            ]
        },
        {
            path: '/auth',
            name: 'auth',
            component: Layout,
            redirect: "/auth/list",
            meta: {
                title: "权限管理",
            },
            children: [
                {
                    path: 'list',
                    name: 'auth-list',
                    component: resolve => { require(['@/views/auth/list'], resolve); },
                    meta: {
                        title: "权限列表"
                    }
                },
                {
                    path: 'create',
                    name: 'auth-create',
                    component: resolve => { require(['@/views/auth/create'], resolve); },
                    meta: {
                        title: "创建权限"
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'auth-edit',
                    props: true,
                    component: resolve => { require(['@/views/auth/create'], resolve); },
                    meta: {
                        title: "编辑权限"
                    }
                }

            ]
        },
        {
            path: '/role',
            name: 'role',
            component: Layout,
            redirect: "/role/list",
            meta: {
                title: "角色管理",
            },
            children: [
                {
                    path: 'list',
                    name: 'role-list',
                    component: resolve => { require(['@/views/role/list'], resolve); },
                    meta: {
                        title: "角色列表"
                    }
                },
                {
                    path: 'create',
                    name: 'role-create',
                    component: resolve => { require(['@/views/role/create'], resolve); },
                    meta: {
                        title: "创建角色"
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'role-edit',
                    props: true,
                    component: resolve => { require(['@/views/role/create'], resolve); },
                    meta: {
                        title: "编辑角色"
                    }
                }

            ]
        },
        {
            path: '/category',
            name: 'category',
            component: Layout,
            meta: {
                title: "分类管理",
                navPath: "",
            },
            children: [
                {
                    path: 'museum',
                    name: 'category-museum',
                    props: true,
                    component: resolve => { require(['@/views/category/museum'], resolve); },
                    meta: {
                        title: "博物馆分类",
                    }
                },
                {
                    path: 'material',
                    name: 'category-material',
                    props: true,
                    component: resolve => { require(['@/views/category/material'], resolve); },
                    meta: {
                        title: "素材类别",
                    }
                },
                {
                    path: 'derivative',
                    name: 'category-derivative',
                    props: true,
                    component: resolve => { require(['@/views/category/derivative'], resolve); },
                    meta: {
                        title: "衍生品品类",
                    }
                },
                {
                    path: 'enterprise',
                    name: 'category-enterprise',
                    props: true,
                    component: resolve => { require(['@/views/category/enterprise'], resolve); },
                    meta: {
                        title: "机构分类",
                    }
                },
                {
                    path: ':type/edit/:id',
                    name: 'category-edit',
                    props: true,
                    component: resolve => { require(['@/views/category/create'], resolve); },
                    meta: {
                        title: "编辑"
                    }
                },
                {
                    path: ':type/create',
                    name: 'category-create',
                    props: true,
                    component: resolve => { require(['@/views/category/create'], resolve); },
                    meta: {
                        title: "添加"
                    }
                }
            ]
        },
        {
            path: '/museum',
            name: 'museum',
            component: Layout,
            meta: {
                title: "博物馆管理",
                navPath: "",
            },
            children: [
                {
                    path: 'list',
                    name: 'museum-list',
                    component: resolve => { require(['@/views/museum/list'], resolve); },
                    meta: {
                        title: "博物馆列表",
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'museum-edit',
                    props: true,
                    component: resolve => { require(['@/views/museum/create'], resolve); },
                    meta: {
                        title: "编辑博物馆"
                    }
                },
                {
                    path: 'create',
                    name: 'museum-create',
                    component: resolve => { require(['@/views/museum/create'], resolve); },
                    meta: {
                        title: "添加博物馆"
                    }
                },
                {
                    path: 'detail/:id',
                    name: 'museum-detail',
                    props: true,
                    component: resolve => { require(['@/views/museum/detail'], resolve); },
                    meta: {
                        title: "博物馆详情"
                    }
                }
            ]
        },
        {
            path: '/enterprise',
            name: 'enterprise',
            component: Layout,
            meta: {
                title: "机构管理",
                navPath: "",
            },
            children: [
                {
                    path: 'list',
                    name: 'enterprise-list',
                    component: resolve => { require(['@/views/enterprise/list'], resolve); },
                    meta: {
                        title: "机构列表",
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'enterprise-edit',
                    props: true,
                    component: resolve => { require(['@/views/enterprise/create'], resolve); },
                    meta: {
                        title: "编辑机构"
                    }
                },
                {
                    path: 'create',
                    name: 'enterprise-create',
                    component: resolve => { require(['@/views/enterprise/create'], resolve); },
                    meta: {
                        title: "添加机构"
                    }
                },
                {
                    path: 'detail/:id',
                    name: 'enterprise-detail',
                    props: true,
                    component: resolve => { require(['@/views/enterprise/detail'], resolve); },
                    meta: {
                        title: "机构详情"
                    }
                }
            ]
        },
        {
            path: '/design',
            name: 'design',
            component: Layout,
            meta: {
                title: "设计师管理",
                navPath: "",
            },
            children: [
                {
                    path: 'list',
                    name: 'design-list',
                    component: resolve => { require(['@/views/design/list'], resolve); },
                    meta: {
                        title: "设计师列表",
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'design-edit',
                    props: true,
                    component: resolve => { require(['@/views/design/create'], resolve); },
                    meta: {
                        title: "编辑设计师"
                    }
                },
                {
                    path: 'create',
                    name: 'design-create',
                    component: resolve => { require(['@/views/design/create'], resolve); },
                    meta: {
                        title: "添加设计师"
                    }
                },
                {
                    path: 'detail/:id',
                    name: 'design-detail',
                    props: true,
                    component: resolve => { require(['@/views/design/detail'], resolve); },
                    meta: {
                        title: "设计师详情"
                    }
                }
            ]
        },
        {
            path: '/material',
            name: 'material',
            component: Layout,
            meta: {
                title: "素材管理",
                navPath: "",
            },
            children: [
                {
                    path: 'list',
                    name: 'material-list',
                    component: resolve => { require(['@/views/material/list'], resolve); },
                    meta: {
                        title: "素材列表",
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'material-edit',
                    props: true,
                    component: resolve => { require(['@/views/material/create'], resolve); },
                    meta: {
                        title: "编辑素材"
                    }
                },
                {
                    path: 'create',
                    name: 'material-create',
                    component: resolve => { require(['@/views/material/create'], resolve); },
                    meta: {
                        title: "添加素材"
                    }
                },
                {
                    path: 'detail/:id',
                    name: 'material-detail',
                    props: true,
                    component: resolve => { require(['@/views/material/detail'], resolve); },
                    meta: {
                        title: "素材详情"
                    }
                }
            ]
        },
        {
            path: '/derivative',
            name: 'derivative',
            component: Layout,
            meta: {
                title: "文创作品管理",
                navPath: "",
            },
            children: [
                {
                    path: 'list',
                    name: 'derivative-list',
                    component: resolve => { require(['@/views/derivative/list'], resolve); },
                    meta: {
                        title: "文创作品列表",
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'derivative-edit',
                    props: true,
                    component: resolve => { require(['@/views/derivative/create'], resolve); },
                    meta: {
                        title: "编辑文创作品"
                    }
                },
                {
                    path: 'create',
                    name: 'derivative-create',
                    component: resolve => { require(['@/views/derivative/create'], resolve); },
                    meta: {
                        title: "添加文创作品"
                    }
                },
                {
                    path: 'detail/:id',
                    name: 'derivative-detail',
                    props: true,
                    component: resolve => { require(['@/views/derivative/detail'], resolve); },
                    meta: {
                        title: "文创作品详情"
                    }
                }
            ]
        },
        {
            path: '/news',
            name: 'news',
            component: Layout,
            meta: {
                title: "网站管理",
                navPath: "",
            },
            children: [
                {
                    path: 'list',
                    name: 'news-list',
                    component: resolve => { require(['@/views/news/list'], resolve); },
                    meta: {
                        title: "新闻列表",
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'news-edit',
                    props: true,
                    component: resolve => { require(['@/views/news/create'], resolve); },
                    meta: {
                        title: "编辑新闻"
                    }
                },
                {
                    path: 'create',
                    name: 'news-create',
                    component: resolve => { require(['@/views/news/create'], resolve); },
                    meta: {
                        title: "添加新闻"
                    }
                },
                {
                    path: 'detail/:id',
                    name: 'news-detail',
                    props: true,
                    component: resolve => { require(['@/views/news/detail'], resolve); },
                    meta: {
                        title: "新闻详情"
                    }
                }
            ]
        },
        {
            path: '/activity',
            name: 'activity',
            component: Layout,
            meta: {
                title: "网站管理",
                navPath: "",
            },
            children: [
                {
                    path: 'list',
                    name: 'activity-list',
                    component: resolve => { require(['@/views/activity/list'], resolve); },
                    meta: {
                        title: "活动列表",
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'activity-edit',
                    props: true,
                    component: resolve => { require(['@/views/activity/create'], resolve); },
                    meta: {
                        title: "编辑新闻"
                    }
                },
                {
                    path: 'create',
                    name: 'activity-create',
                    component: resolve => { require(['@/views/activity/create'], resolve); },
                    meta: {
                        title: "添加活动"
                    }
                },
                {
                    path: 'detail/:id',
                    name: 'activity-detail',
                    props: true,
                    component: resolve => { require(['@/views/activity/detail'], resolve); },
                    meta: {
                        title: "活动详情"
                    }
                }
            ]
        },
        {
            path: '/campaign',
            name: 'campaign',
            component: Layout,
            meta: {
                title: "定制活动",
                navPath: "",
            },
            children: [
                {
                    path: 'works/list',
                    name: 'works-list',
                    component: resolve => { require(['@/views/campaign/works/list'], resolve); },
                    meta: {
                        title: "个人报名列表",
                    }
                },
                {
                    path: 'works/edit/:id',
                    name: 'works-edit',
                    props: true,
                    component: resolve => { require(['@/views/campaign/works/create'], resolve); },
                    meta: {
                        title: "编辑新闻"
                    }
                },
                {
                    path: 'works/detail/:id',
                    name: 'works-detail',
                    props: true,
                    component: resolve => { require(['@/views/campaign/works/detail'], resolve); },
                    meta: {
                        title: "作品详情"
                    }
                },
                {
                    path: 'personal/list',
                    name: 'activity-list',
                    component: resolve => { require(['@/views/campaign/personal/list'], resolve); },
                    meta: {
                        title: "个人报名列表",
                    }
                },
                {
                    path: 'personal/edit/:id',
                    name: 'activity-edit',
                    props: true,
                    component: resolve => { require(['@/views/campaign/personal/create'], resolve); },
                    meta: {
                        title: "编辑新闻"
                    }
                },
                {
                    path: 'personal/create',
                    name: 'activity-create',
                    component: resolve => { require(['@/views/campaign/personal/create'], resolve); },
                    meta: {
                        title: "添加活动"
                    }
                },
                {
                    path: 'personal/detail/:id',
                    name: 'activity-detail',
                    props: true,
                    component: resolve => { require(['@/views/campaign/personal/detail'], resolve); },
                    meta: {
                        title: "个人报名详情"
                    }
                },
                 {
                    path: 'personal/works/:id',
                    name: 'activity-detail',
                    props: true,
                    component: resolve => { require(['@/views/campaign/personal/works'], resolve); },
                    meta: {
                        title: "作品详情"
                    }
                },
                {
                    path: 'company/list',
                    name: 'activity-list',
                    component: resolve => { require(['@/views/campaign/company/list'], resolve); },
                    meta: {
                        title: "企业报名列表",
                    }
                },
                {
                    path: 'company/edit/:id',
                    name: 'activity-edit',
                    props: true,
                    component: resolve => { require(['@/views/campaign/company/create'], resolve); },
                    meta: {
                        title: "编辑新闻"
                    }
                },
                {
                    path: 'company/create',
                    name: 'activity-create',
                    component: resolve => { require(['@/views/campaign/company/create'], resolve); },
                    meta: {
                        title: "添加活动"
                    }
                },
                {
                    path: 'company/detail/:id',
                    name: 'activity-detail',
                    props: true,
                    component: resolve => { require(['@/views/campaign/company/detail'], resolve); },
                    meta: {
                        title: "企业详情"
                    }
                },
                {
                    path: 'company/works/:id',
                    name: 'work-detail',
                    props: true,
                    component: resolve => { require(['@/views/campaign/company/works'], resolve); },
                    meta: {
                        title: "作品详情"
                    }
                },
                {
                    path: 'agency/list',
                    name: 'activity-list',
                    component: resolve => { require(['@/views/campaign/agency/list'], resolve); },
                    meta: {
                        title: "文博单位报名列表",
                    }
                },
                {
                    path: 'agency/edit/:id',
                    name: 'activity-edit',
                    props: true,
                    component: resolve => { require(['@/views/campaign/agency/create'], resolve); },
                    meta: {
                        title: "编辑新闻"
                    }
                },
                {
                    path: 'agency/create',
                    name: 'activity-create',
                    component: resolve => { require(['@/views/campaign/agency/create'], resolve); },
                    meta: {
                        title: "添加活动"
                    }
                },
                {
                    path: 'agency/detail/:id',
                    name: 'activity-detail',
                    props: true,
                    component: resolve => { require(['@/views/campaign/agency/detail'], resolve); },
                    meta: {
                        title: "文博单位报名详情"
                    }
                },
                {
                    path: 'agency/works/:id',
                    name: 'activity-detail',
                    props: true,
                    component: resolve => { require(['@/views/campaign/agency/works'], resolve); },
                    meta: {
                        title: "文博单位作品详情"
                    }
                },
            ]
        },
        {
            path: '/banner',
            name: 'banner',
            component: Layout,
            meta: {
                title: "网站管理",
            },
            children: [
                {
                    path: 'list',
                    name: 'banner-list',
                    component: resolve => { require(['@/views/banner/list'], resolve); },
                    meta: {
                        title: "推广列表",
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'banner-edit',
                    props: true,
                    component: resolve => { require(['@/views/banner/create'], resolve); },
                    meta: {
                        title: "编辑推广"
                    }
                },
                {
                    path: 'create',
                    name: 'banner-create',
                    component: resolve => { require(['@/views/banner/create'], resolve); },
                    meta: {
                        title: "添加推广"
                    }
                },
            ]
        },
        {
            path: '/policy',
            name: 'policy',
            component: Layout,
            meta: {
                title: "网站管理",
            },
            children: [
                {
                    path: 'list',
                    name: 'policy-list',
                    component: resolve => { require(['@/views/policy/list'], resolve); },
                    meta: {
                        title: "政策列表",
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'policy-edit',
                    props: true,
                    component: resolve => { require(['@/views/policy/create'], resolve); },
                    meta: {
                        title: "编辑政策"
                    }
                },
                {
                    path: 'create',
                    name: 'policy-create',
                    component: resolve => { require(['@/views/policy/create'], resolve); },
                    meta: {
                        title: "添加政策"
                    }
                },
                {
                    path: 'detail/:id',
                    name: 'policy-detail',
                    props: true,
                    component: resolve => { require(['@/views/policy/detail'], resolve); },
                    meta: {
                        title: "政策详情"
                    }
                }
            ]
        },
        {
            path: '/demand',
            name: 'demand',
            component: Layout,
            meta: {
                title: "网站管理",
            },
            children: [
                {
                    path: 'list',
                    name: 'demand-list',
                    component: resolve => { require(['@/views/demand/list'], resolve); },
                    meta: {
                        title: "合作需求列表",
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'demand-edit',
                    props: true,
                    component: resolve => { require(['@/views/demand/create'], resolve); },
                    meta: {
                        title: "编辑合作需求"
                    }
                },
                {
                    path: 'create',
                    name: 'demand-create',
                    component: resolve => { require(['@/views/demand/create'], resolve); },
                    meta: {
                        title: "添加合作需求"
                    }
                },
                {
                    path: 'detail/:id',
                    name: 'demand-detail',
                    props: true,
                    component: resolve => { require(['@/views/demand/detail'], resolve); },
                    meta: {
                        title: "合作需求详情"
                    }
                }
            ]
        },
        {
            path: '/user',
            name: 'user',
            component: Layout,
            redirect: "/user/list",
            meta: {
                title: "用户管理",
                navPath: "",
            },
            children: [
                {
                    path: 'list',
                    name: 'user-list',
                    component: resolve => { require(['@/views/user/list'], resolve); },
                    meta: {
                        title: "用户列表",
                    }
                },
                {
                    path: 'edit/:uid',
                    name: 'user-edit',
                    props: true,
                    component: resolve => { require(['@/views/user/create'], resolve); },
                    meta: {
                        title: "编辑用户"
                    }
                },
                {
                    path: 'create',
                    name: 'user-create',
                    component: resolve => { require(['@/views/user/create'], resolve); },
                    meta: {
                        title: "新增用户"
                    }
                },
                {
                    path: 'detail/:id',
                    name: 'user-detail',
                    props: true,
                    component: resolve => { require(['@/views/user/detail'], resolve); },
                    meta: {
                        title: "用户详情"
                    }
                }
            ]
        },
        {
            path: '/site',
            name: 'site',
            component: Layout,
            meta: {
                title: "网站管理",
            },
            children: [
                {
                    path: 'museum',
                    name: 'site-museum',
                    component: resolve => { require(['@/views/site/museum'], resolve); },
                    meta: {
                        title: "博物馆",
                    }
                },
                // {
                //     path: 'museumRecommend',
                //     name: 'site-museum-recommend',
                //     component: resolve => { require(['@/views/site/museum'], resolve); },
                //     meta: {
                //         title: "博物馆推荐",
                //     }
                // }
            ]
        },

        {
            path: '/museumRecommend',
            name: 'museumRecommend',
            component: Layout,
            meta: {
                title: "网站管理",
                navPath: "",
            },
            children: [

                {
                    path: 'edit/:id',
                    name: 'museum-recommend-edit',
                    props: true,
                    component: resolve => { require(['@/views/museumRecommend/create'], resolve); },
                    meta: {
                        title: "编辑博物馆推荐"
                    }
                },
                {
                    path: 'create',
                    name: 'museum-recommend-create',
                    component: resolve => { require(['@/views/museumRecommend/create'], resolve); },
                    meta: {
                        title: "添加博物馆推荐"
                    }
                },
                {
                    path: 'detail',
                    name: 'museum-recommend-detail',
                    props: true,
                    component: resolve => { require(['@/views/museumRecommend/detail'], resolve); },
                    meta: {
                        title: "博物馆推荐详情"
                    }
                }
            ]
        },

        {
            path: '/advertise',
            name: 'advertise',
            component: Layout,
            meta: {
                title: "网站管理",
                navPath: "",
            },
            children: [

                {
                    // path: 'edit/:id',
                    path: 'edit',
                    name: 'advertise-edit',
                    props: true,
                    component: resolve => { require(['@/views/advertise/create'], resolve); },
                    meta: {
                        title: "编辑广告图"
                    }
                },
                {
                    path: 'create',
                    name: 'advertise-create',
                    component: resolve => { require(['@/views/advertise/create'], resolve); },
                    meta: {
                        title: "添加广告图"
                    }
                },
                {
                    path: 'detail',
                    name: 'advertise-detail',
                    props: true,
                    component: resolve => { require(['@/views/advertise/detail'], resolve); },
                    meta: {
                        title: "广告图设置"
                    }
                }
            ]
        },
        {
            path: '/visual',
            name: 'visual',
            component: Layout,
            meta: {
                title: "网站管理",
                navPath: "",
            },
            children: [

                {
                    path: 'edit/:id',
                    name: 'visual-edit',
                    props: true,
                    component: resolve => { require(['@/views/visual/create'], resolve); },
                    meta: {
                        title: "编辑数据"
                    }
                },
                {
                    path: 'create',
                    name: 'visual-create',
                    component: resolve => { require(['@/views/visual/create'], resolve); },
                    meta: {
                        title: "添加广告图"
                    }
                },
                {
                    path: 'detail',
                    name: 'visual-detail',
                    props: true,
                    component: resolve => { require(['@/views/visual/detail'], resolve); },
                    meta: {
                        title: "数据详情"
                    }
                }
            ]
        },
        {
            path: '/message',
            name: 'message',
            component: Layout,
            meta: {
                title: "网站管理",
                navPath: "",
            },
            children: [
                {
                    path: 'list',
                    name: 'message-list',
                    component: resolve => { require(['@/views/message/list'], resolve); },
                    meta: {
                        title: "留言列表",
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'message-edit',
                    props: true,
                    component: resolve => { require(['@/views/message/create'], resolve); },
                    meta: {
                        title: "编辑数据"
                    }
                },
                {
                    path: 'create',
                    name: 'message-create',
                    component: resolve => { require(['@/views/message/create'], resolve); },
                    meta: {
                        title: "留言详情"
                    }
                },
                {
                    path: 'detail/:id',
                    name: 'message-detail',
                    props: true,
                    component: resolve => { require(['@/views/message/detail'], resolve); },
                    meta: {
                        title: "留言详情"
                    }
                }
            ]
        },
        {
            path: '/tags',
            name: 'tags',
            component: Layout,
            meta: {
                title: "网站管理",
                navPath: "",
            },
            children: [
                {
                    path: 'list',
                    name: 'tags-list',
                    component: resolve => { require(['@/views/tags/list'], resolve); },
                    meta: {
                        title: "标签列表",
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'tags-edit',
                    props: true,
                    component: resolve => { require(['@/views/tags/create'], resolve); },
                    meta: {
                        title: "编辑标签"
                    }
                },
                {
                    path: 'create',
                    name: 'tags-create',
                    component: resolve => { require(['@/views/tags/create'], resolve); },
                    meta: {
                        title: "标签详情"
                    }
                },
                {
                    path: 'detail/:id',
                    name: 'tags-detail',
                    props: true,
                    component: resolve => { require(['@/views/tags/detail'], resolve); },
                    meta: {
                        title: "标签详情"
                    }
                }
            ]
        },

        {
            path: '/wcbm',
            name: 'wcbm',
            component: Layout,
            meta: {
                title: "文创报名管理",
                navPath: "",
            },
            children: [
                {
                    path: 'list',
                    name: 'wcbm-list',
                    component: resolve => { require(['@/views/wcbm/list'], resolve); },
                    meta: {
                        title: "文创报名列表",
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'wcbm-edit',
                    props: true,
                    component: resolve => { require(['@/views/wcbm/create'], resolve); },
                    meta: {
                        title: "编辑数据"
                    }
                },
                {
                    path: 'create',
                    name: 'wcbm-create',
                    component: resolve => { require(['@/views/wcbm/create'], resolve); },
                    meta: {
                        title: "文创报名详情"
                    }
                },
                {
                    path: 'detail/:id/:show',
                    name: 'wcbm-detail',
                    props: true,
                    component: resolve => { require(['@/views/wcbm/detail'], resolve); },
                    meta: {
                        title: "文创报名详情"
                    }
                }
            ]
        },

        {
            path: '/artwork',
            name: 'artwork',
            component: Layout,
            meta: {
                title: "作品管理",
                navPath: "",
            },
            children: [
                {
                    path: 'list',
                    name: 'artwork-list',
                    component: resolve => { require(['@/views/artwork/list'], resolve); },
                    meta: {
                        title: "作品列表",
                    }
                },
                {
                    path: 'edit/:id',
                    name: 'artwork-edit',
                    props: true,
                    component: resolve => { require(['@/views/artwork/create'], resolve); },
                    meta: {
                        title: "编辑作品"
                    }
                },
                {
                    path: 'create',
                    name: 'artwork-create',
                    component: resolve => { require(['@/views/artwork/create'], resolve); },
                    meta: {
                        title: "添加作品"
                    }
                },
                {
                    path: 'detail/:id',
                    name: 'artwork-detail',
                    props: true,
                    component: resolve => { require(['@/views/artwork/detail'], resolve); },
                    meta: {
                        title: "作品详情"
                    }
                }
            ]
        },
        {
            path: '/*',
            name: '404',
            component: resolve => { require(['@/views/error/404'], resolve); },
            meta: {
                title: "404错误"
            }
        }
    ]


export default {
    list
}



// WEBPACK FOOTER //
// ./src/router/router.js